import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'
import { useNextIsClientHydrated } from '@/lib/next/useNextIsClientHydrated'

export function useIsActiveHideVatPrice(): boolean {
  const { config } = useSiteConfig()
  const isClientHydrated = useNextIsClientHydrated()

  // useSiteConfig() is skipped during SSR, so we stay false until hydrated to avoid a mismatch if the client's Apollo cache is already warm.
  return isClientHydrated ? (config?.catalog?.isActiveHideVatPrice ?? false) : false
}
